import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

const DemoBrandOfferView: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();

  // Get the most recent item from state
  const product = state.lastAddedProduct;
  const item = {
    name: product?.name || "Demo Brand Item",
    brand: product?.brand || "Demo Brand",
    condition: "Good",
    estimatedValue: product?.rewardValue || 45,
  };

  const handleAccept = () => {
    navigate("/demobrand/confirmation");
  };

  const handleDecline = () => {
    navigate("/demobrand");
  };

  const handleBack = () => {
    navigate("/demobrand/scan");
  };

  return (
    <div className="min-h-screen bg-[#0A1628] flex flex-col">
      {/* Header */}
      <header className="py-6 px-8 flex items-center justify-between">
        <button
          onClick={handleBack}
          className="text-white/60 hover:text-white transition-colors flex items-center gap-2"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
        <div className="flex items-center gap-3">
          <span className="text-white font-semibold text-xl">Demo Brand</span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-8 pb-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <svg
              className="w-6 h-6 text-[#22C55E]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-[#22C55E] font-semibold uppercase tracking-wider">
              Item Identified
            </span>
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">Your Offer</h1>
        </motion.div>

        {/* Offer Card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="bg-white/5 rounded-2xl p-8 border border-white/10 max-w-md w-full mb-8"
        >
          {/* Item Details */}
          <div className="text-center mb-6 pb-6 border-b border-white/10">
            <h2 className="text-white font-bold text-xl mb-2">{item.name}</h2>
            <p className="text-white/60">
              Brand: {item.brand} | Condition: {item.condition}
            </p>
          </div>

          {/* Offer Amount */}
          <div className="text-center">
            <p className="text-white/60 mb-2">Your Store Credit</p>
            <div className="text-5xl font-bold text-[#0066CC] mb-2">
              ${item.estimatedValue}
            </div>
            <p className="text-white/40 text-sm">
              Valid for 12 months on any purchase
            </p>
          </div>
        </motion.div>

        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          className="flex gap-4"
        >
          <button
            onClick={handleDecline}
            className="px-8 py-4 rounded-lg font-bold tracking-wider border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="bg-[#0066CC] text-white px-12 py-4 rounded-lg font-bold tracking-wider shadow-xl hover:bg-[#0055AA] transition-colors"
          >
            Accept Offer
          </button>
        </motion.div>

        {/* Terms */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.5 }}
          className="text-white/40 text-sm mt-6 text-center max-w-md"
        >
          By accepting, you agree to transfer ownership of this item. Credit
          will be added to your account immediately.
        </motion.p>
      </main>

      {/* Footer */}
      <footer className="py-4 px-8 text-center text-white/40 text-sm border-t border-white/10">
        Powered by Pentatonic AI
      </footer>
    </div>
  );
};

export default DemoBrandOfferView;
